<template>
    <BaseModal
        size="modal-lg"
        class="enter-discount-open-value-modal"
        :closable="false"
        ref="baseModalComponent"
        :title="translations.discounts.value"
    >
        <template v-slot:body>
            <div class="input-container">
                <div v-if="props.discountType === DiscountType.Absolute">
                    <CurrencyInput
                        style="width: 60%"
                        :invalid="absoluteOpenValueInvalid"
                        :min="0.01"
                        :maxFractionDigit="2"
                        :minFractionDigits="2"
                        v-model="absoluteOpenValue"
                    />
                </div>
                <div v-if="props.discountType === DiscountType.Percentage">
                    <CurrencyInput
                        :invalid="absoluteOpenValueInvalid"
                        :min="0.0001"
                        :max="100"
                        style="width: 60%"
                        :maxFractionDigits="4"
                        :minFractionDigits="4"
                        v-model="percentageOpenValue"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button type="button" class="btn btn-secondary" @click="closePopup">
                {{ translations.general.cancel }}
            </button>
            <button type="button" class="btn btn-success" @click="applyDiscountOpenValue">
                {{ translations.general.apply }}
            </button>
        </template>
    </BaseModal>
</template>

<script setup lang="ts">
import { DiscountType } from "@/data/model/Enums";
import { translations } from "@/shared/localization/translations";
import { ref } from "vue";



import BaseModal from "@/components/dialog/BaseModal.vue";
import CurrencyInput from "@/components/elements/CurrencyInput.vue";


const emit = defineEmits(["onClose"]);

    const props = defineProps<{
        onEnterValue: (value: number) => void;
        discountType: DiscountType;
    }>();

    const absoluteOpenValue = ref<number | null>(null);
    const percentageOpenValue = ref<number | null>(null);
    const baseModalComponent = ref<InstanceType<typeof BaseModal> | null>(null);
    const absoluteOpenValueInvalid = ref<boolean>(false);
    const percentageOpenValueInvalid = ref<boolean>(false);

    function applyDiscountOpenValue(): void {
        switch (props.discountType) {
            case DiscountType.Absolute:
                absoluteOpenValueInvalid.value = false;
                if (absoluteOpenValue.value == null) {
                    absoluteOpenValueInvalid.value = true;
                } else {
                    props.onEnterValue(absoluteOpenValue.value!);
                    emit("onClose");
                    closePopup();
                }
                break;
            case DiscountType.Percentage:
                percentageOpenValueInvalid.value = false;
                if (percentageOpenValue.value == null) {
                    percentageOpenValueInvalid.value = true;
                } else {
                    props.onEnterValue(percentageOpenValue.value!);
                    emit("onClose");
                    closePopup();
                }
                break;
        }
    }

    function closePopup() {
        emit("onClose");
        close();
    }

    function show() {
        baseModalComponent.value?.show();
    }

    function close() {
        baseModalComponent.value?.close();
    }

    defineExpose({
        show,
        close,
    });
</script>

<style lang="scss">
    .enter-discount-open-value-modal {
        background-color: rgba(0, 0, 0, 0.5) !important;

        .input-container {
            margin: 14px 0;
            text-align: center;
        }
    }
</style>